import React from "react";
import PageTemplate from "../components/template/PageTemplate"

const Portfolio = () => {
  return (
    <PageTemplate>
    <section className="page-content">
      <h1 className="page-heading">My Work</h1>
      <p>Here are some of my recent projects.</p>
    </section>
    </PageTemplate>
  );
};

export default Portfolio;
